import { Api } from "../api";
import React from "react";
import * as firebase from "../firebase";

export const AppContext = React.createContext({
  api: new Api(),
  firebase: firebase
});
